import { client, isSanityConfigured } from './client'
import { contactDetailsQuery, teamMembersQuery } from './queries'

export interface ContactDetails {
  addressLine1: string | null
  addressLine2: string | null
  city: string | null
  postcode: string | null
  phone: string | null
  phoneRaw: string | null
  email: string | null
  companyRegistration: string | null
}

export interface SanityImage {
  _type: 'image'
  asset: {
    _ref: string
    _type: 'reference'
  }
  hotspot?: {
    x: number
    y: number
    height: number
    width: number
  }
  crop?: {
    top: number
    bottom: number
    left: number
    right: number
  }
}

export interface TeamMember {
  _id: string
  name: string
  role: string
  company: string | null
  bio: string | null
  email: string | null
  image: SanityImage | null
  featured: boolean | null
}

export async function getContactDetails(): Promise<ContactDetails | null> {
  if (!isSanityConfigured() || !client) {
    return null
  }
  return client.fetch(contactDetailsQuery)
}

export async function getTeamMembers(): Promise<TeamMember[]> {
  if (!isSanityConfigured() || !client) {
    return []
  }
  return client.fetch(teamMembersQuery)
}
